export default __webpack_public_path__ + "static/media/Cartão Pequenos Artistas - Cat. II.284bdadf.png";